module.exports = __webpack_public_path__ + "img/ZAG-Bild.ef9ad127.jpg";